/* ============================================================
   AEROS FANS — MAIN JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile Nav ----
  const mobileToggle = document.querySelector('.mobile-nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileOverlay = document.getElementById('mobile-nav-overlay');
  const mobileClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    mobileOverlay && mobileOverlay.classList.add('is-visible');
    mobileToggle && mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileOverlay && mobileOverlay.classList.remove('is-visible');
    mobileToggle && mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  mobileToggle && mobileToggle.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);

  // ---- Product Gallery Thumbnails ----
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.querySelector('.product-gallery__main img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImage) {
        const src = thumb.querySelector('img').src;
        mainImage.src = src;
      }
    });
  });

  // ---- Product Tabs ----
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.getAttribute('data-tab');
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      tabPanels.forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      const panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('active');
    });
  });

  // ---- Quantity Buttons ----
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const field = btn.closest('.qty-input').querySelector('.qty-field');
      if (!field) return;
      let val = parseInt(field.value) || 1;
      if (btn.classList.contains('qty-minus')) val = Math.max(1, val - 1);
      if (btn.classList.contains('qty-plus')) val = val + 1;
      field.value = val;
    });
  });

  // ---- Sticky Header Shadow ----
  const headerMain = document.querySelector('.header-main');
  if (headerMain) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        headerMain.style.boxShadow = '0 4px 20px rgba(0,0,0,0.35)';
      } else {
        headerMain.style.boxShadow = '0 2px 12px rgba(0,0,0,0.25)';
      }
    }, { passive: true });
  }

  // ---- Cart Count Update (AJAX) ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  // ---- Add to Cart (AJAX) ----
  const addToCartForms = document.querySelectorAll('.product-add-to-cart-form');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added!'; }
          updateCartCount();
          setTimeout(function () {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 2000);
        })
        .catch(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  });

  // ---- Announcement Bar Dismiss ----
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar && sessionStorage.getItem('announcement-dismissed')) {
    announcementBar.style.display = 'none';
  }

});
